import React, { useContext } from "react";
import { SimpleContext } from "../../../../store/context/simple-context";
import TrackedLink from "../../../Analytics/TrackedLink";
import "./index.scss";

const Call = () => {
  const {
    data: { eventCategory },
  } = useContext(SimpleContext);
  return (
    <div className="GP-C-C">
      <p className="GP-C-C__title">
        Have questions or unsure which toolset plan is right for you?
      </p>
      <TrackedLink
        classes="GP-C-C__link"
        category={eventCategory}
        action="Book your call"
        path="https://calendly.com/iness-lagut/30min"
        target
      >
        Book your call
      </TrackedLink>
    </div>
  );
};

export default Call;
